// amcharts4
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

// React Hooks
import { useEffect, useState } from "react";

// Redux Store
import { AppState } from "../../../../store/store";
import { useSelector } from "react-redux";

// Localisation i18n
import { useTranslation } from "react-i18next";

// Services
import OperationsServices from "../../../../services/AuraCamera/operations.service";

// interfaces
import { LeakSizeType } from "../../../../interfaces/AURACamera/operations/max-leak-by-size";

// react prime faces
import { Dropdown } from "primereact/dropdown";

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

const EmissionBySource = (para: any) => {
  // Create chart instance
  const ResizeStoreToSetHeight = useSelector(
    (state: AppState) => state.AuraCameraCommon.StackedBarGraphHeight
  );

  // useStates

  const { t } = useTranslation();

  const [displayChart, displayChartUpdate] = useState("block");
  useEffect(() => {
    // Filterby size logic start
    // check if size is selected
    let chart = am4core.create("chartdiv", am4charts.XYChart);

    let filtered_by_size_array = para?.SortedBarGraph;
    // Unique Records Start


    // Your array of records
const records:any = filtered_by_size_array;

// Create an object to store unique records based on siteName
const uniqueRecords:any = {};

// Iterate through the array and keep only the record with the latest date for each siteName
records.forEach((record:any) => {
  const siteName = record.siteName;

  // If the siteName is not in uniqueRecords or the current record has a later date, update the entry
  if (!uniqueRecords[siteName] || new Date(record.createdOn) > new Date(uniqueRecords[siteName].createdOn)) {
    uniqueRecords[siteName] = record;
  }
});

// Convert the uniqueRecords object back to an array
const result = Object.values(uniqueRecords);





    // Unique Records End
    // Filterby size logic end
    displayChartUpdate("block");
    var GarphData: any = result;
    
    // Add data
    if (GarphData.length > 0) {
      GarphData = [...GarphData];
      GarphData.sort((a: any, b: any) => {
        // return parseFloat(a.AlltotalLeaks) - parseFloat(b.AlltotalLeaks);
        return parseFloat(a.totalLeaks) - parseFloat(b.totalLeaks);
      });
    }

    if (GarphData.length > 10) {
      GarphData = GarphData.slice(0, 10);
    }
    // GarphData = filtered_by_size_array;
    chart.data = GarphData;
    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "siteName";
    categoryAxis.renderer.grid.template.opacity = 0;

    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
    valueAxis.renderer.baseGrid.disabled = true;
    if (chart.logo) {
      chart.logo.disabled = true;
    }
    chart.responsive.enabled = true;
    categoryAxis.renderer.minGridDistance = 10;
    categoryAxis.renderer.fontSize = 11;

    // Create series
    //function createSeries(field: any, name: any, color: any) {
    let strokeColor: any = "#fff";
    let val = "{valueX}";
    if (val !== "" && val !== null) {
      let series = chart.series.push(new am4charts.ColumnSeries());

      series.dataFields.valueX = "totalLeaks";
      series.dataFields.categoryY = "siteName";
      series.stacked = false;
      series.name = "Leaks";
      series.columns.template.tooltipText = "{categoryY} : {name} {valueX}";
      var labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "{valueX}";
      labelBullet.label.horizontalCenter = "right";
      labelBullet.label.paddingRight = 8;
      labelBullet.label.fill = am4core.color("#fff");
      //series.columns.template.fill = am4core.color("#003e51");
      series.columns.template.stroke = strokeColor;

      let columnTemplate = series.columns.template;
      columnTemplate.height = am4core.percent(50);
      columnTemplate.maxHeight = 50;
      columnTemplate.column.cornerRadius(0, 5, 0, 5);
      columnTemplate.strokeOpacity = 0;

      series.heatRules.push({
        target: columnTemplate,
        property: "fill",
        dataField: "valueX",
        min: am4core.color("#e5dc36"),
        max: am4core.color("#5faa46"),
      });
      series.mainContainer.mask = undefined;

      series.columns.template.adapter.add("fill", function (fill, target: any) {
        return chart.colors.getIndex(target.dataItem.index);
      });

      labelBullet.label.adapter.add(
        "textOutput",
        function (text: any, target: any) {
          // Hide labels with 0 value
          if (target.dataItem && target.dataItem.valueX == 0) {
            return "";
          }
          return text;
        }
      );
    }
    // }
    // return () =>{
    //   if (true) {
    //     setTimeout(() => {
    //       displayChartUpdate("block");
    //       chart.dispose();
    //     }, 2000);
    //   }
    return () => {
      displayChartUpdate("block");

      chart.dispose();
    };
  }, [para?.SortedBarGraph]);

  return (
    <>
      {para?.SortedBarGraph?.length > 0 ? (
        ""
      ) : (
        <div
          style={{
            padding: "24px",
            textAlign: "center",
            marginTop: "20px",
            color: "rgba(0,0,0,0.87)",
          }}
        >
          {t("NoRecordsToDisplay")}
        </div>
      )}
      <div
        id="chartdiv"
        style={{
          display: displayChart,
          width: "100%",
          height: ResizeStoreToSetHeight ? "550px" : "550px",
        }}
      ></div>
    </>
  );
};

export default EmissionBySource;
